const SHOP_ALL_STYLES = {
  TOGGLE_TITLE: "Click to toggle selection",
  OUT_OF_STOCK_TEXT: "OUT OF STOCK",
  LIMIT_BREACH:
    "Well, it looks like you tried to add a few items more than their maximum allowed quantity. Don't worry, we've added the maximum allowed",
  ADD_TO_BAG_ERROR: "well that's embaressing! Please try again.",
  ADD_WHILE_ADDING: "Jumping the gun eh? Please wait till we finish",
  ATLEAST_ONE_PRODUCT: "Please select atleast one item to add",
  ADD_TO_BAG_SUCCESS: "Yay! We've added the items to your bag.",
  SCROLL_TIME: 300,
  SELECT_SIZE_TEXT: "Please select a size for all the selected items",
  BUTTON_TEXT: "SHOP ALL STYLES",
  PRODUCT_COUNT_TEXT: " Product$plural",
  TOTAL_TEXT: "Total: ",
  ADD_TO_BAG_TEXT: "ADD TO BAG",
  DEFAULT_SKU_SELECT: {
    discountInPercentage: 0,
    inStock: true,
    maxQuantityDisplayed: 5,
    mrp: 5599,
    price: 5599,
    sellableQuantity: 30,
    size: "Select",
    skuId: "0",
  },
  SIZE_TEXT: "Size:",
  QTY_TEXT: "Qty:",
  COLOR_TEXT: "Color:",
};

const SHOP_MULTILPE = { SHOP_ALL_STYLES };

export default SHOP_MULTILPE;



// WEBPACK FOOTER //
// ./src/constants/multiShop.js